export default function getHighlights(
  text: string,
  highlight: string,
): Array<string> {
  if (!highlight) return [text];
  return text.split(new RegExp(`(${highlight})`, "gi"));
}
